module.exports = __webpack_public_path__ + "pdf/filtration.580a088.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/pdf/filtration.pdf
// module id = a73x
// module chunks = 0